import script from "./PerformerProjectFormStep9.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformerProjectFormStep9.vue?vue&type=script&setup=true&lang=js"

import "./PerformerProjectFormStep9.vue?vue&type=style&index=0&id=034608cd&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-034608cd"]])

export default __exports__